export default "__VITE_ASSET__54729bfb__"